
import {
	Component,
	Inject,
	OnInit,
	AfterViewInit,
	Input,
	ViewChild,
} from "@angular/core";
import { IColunasGrid, IMatrizRiscoControle, IMatrizRiscoControleAtividade } from "../../model/matriz-risco-controle.model";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { GridAbasMatrizRiscoComponent } from "../grid-abas-matriz-risco/grid-abas-matriz-risco.component";
import { BaseListComponent } from "src/app/shared/components/base-list/base-list.component";
@Component({
	selector: "app-mr-aba-atividades",
	templateUrl: "./mr-aba-atividades.component.html",
	styleUrls: ["./mr-aba-atividades.component.scss"],
})
export class MrAbaAtividadesComponent extends BaseListComponent implements OnInit, AfterViewInit {
	@Input() objPrincipal!: IMatrizRiscoControle;
	@Input() visualizar: boolean;

	listColunas: IColunasGrid[] = [
		{ id: "posicao", label: "Ref" },
		{ id: "descricao", label: "Descrição" }
	];

	descricaoAtividade!: string;
	nomeResponsavel!: string;
	descricaoRealizacao!: string;

	objEditar: IMatrizRiscoControleAtividade = null;

	constructor() {
		super();
	}

	ngOnInit(): void {

	}

	ngAfterViewInit() {

	}

	adicionar() {
		if (this.descricaoAtividade == "" || this.descricaoAtividade == undefined) {
			this.exibirMensagemAlerta("Informe a descrição da Atividade!");
			return;
		}

		if (this.descricaoAtividade != "" && this.descricaoAtividade != undefined) {
			if (this.descricaoAtividade.length < 2 || this.descricaoAtividade.length > 255) {
				this.exibirMensagemAlerta("A descrição da Atividade deve ter entre 2 e 255 caracteres!");
				return;
			}
		}

		if (this.nomeResponsavel != "" && this.nomeResponsavel != undefined) {
			if (this.nomeResponsavel.length < 2 || this.nomeResponsavel.length > 255) {
				this.exibirMensagemAlerta("Responsável pela atividade deve ter entre 2 e 255 caracteres!");
				return;
			}
		}

		if (this.descricaoRealizacao != "" && this.descricaoRealizacao != undefined) {
			if (this.descricaoRealizacao.length < 10 || this.descricaoRealizacao.length > 555) {
				this.exibirMensagemAlerta("A descrição de Como é realizada deve ter entre 10 e 555 caracteres!");
				return;
			}
		}

		if (this.objPrincipal.atividades == null)
			this.objPrincipal.atividades = [];

		if (this.objEditar == null) {
			const nova:IMatrizRiscoControleAtividade = {} as IMatrizRiscoControleAtividade;
			nova.id = 0;
			nova.descricao = this.descricaoAtividade;
			nova.responsavel = this.nomeResponsavel;
			nova.comoRealizada = this.descricaoRealizacao;
			nova.idMatrizRiscoControle = this.objPrincipal.id;
			nova.posicao = this.objPrincipal.atividades.length + 1;
			nova.controle = this.objPrincipal.atividades.length + 1;
			this.objPrincipal.atividades.push(nova);
		}
		else {
			this.objEditar.descricao = this.descricaoAtividade;
			this.objEditar.responsavel = this.nomeResponsavel;
			this.objEditar.comoRealizada = this.descricaoRealizacao;
		}
		this.objPrincipal.atividades = [...this.objPrincipal.atividades];
		
		this.limpar();
	}

	limpar() {
		this.objEditar = null;
		this.descricaoAtividade = "";
		this.nomeResponsavel = "";
		this.descricaoRealizacao = "";
	}

	remover(obj: IMatrizRiscoControleAtividade) {

		if (this.objPrincipal.riscos.length > 0) {
			if (this.objPrincipal.riscos.some(s => s.controleAtividade == obj.controle)) {
				this.exibirMensagemAlerta("Não possível remover essa atividade, ela esta sendo usada na aba Riscos Identificados!");
				return;
			}
		}		

		if (obj.id > 0) {
			if (this.objPrincipal.atividadesRemover == undefined) {
				this.objPrincipal.atividadesRemover = [];
			}

			this.objPrincipal.atividadesRemover.push(this.objPrincipal.atividades.find(f => f.id === obj.id));
			this.objPrincipal.atividades = this.objPrincipal.atividades.filter(f => f.id !== obj.id);
		}
		else
			this.objPrincipal.atividades = this.objPrincipal.atividades.filter(f => f.posicao !== obj.posicao);

		this.objPrincipal.atividades = [...this.objPrincipal.atividades];
	}

	editar(obj: IMatrizRiscoControleAtividade) {
		this.objEditar = obj;
		this.descricaoAtividade = obj.descricao;
		this.nomeResponsavel = obj.responsavel;
		this.descricaoRealizacao = obj.comoRealizada;
	}

	novo() {
		this.limpar();
	}

	getNameBtn() {
		if (this.objEditar == null)
			return "Adicionar";
		else
			return "Salvar";
	}
}
